exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles__container___2Dog5{margin:10px;display:flex;align-items:center}.styles__buttonContainer___1nD0g{width:50px;text-align:center}", ""]);

// Exports
exports.locals = {
	"container": "styles__container___2Dog5",
	"buttonContainer": "styles__buttonContainer___1nD0g"
};